import { render, staticRenderFns } from "./marketing-email-index.vue?vue&type=template&id=22a1c81b&"
import script from "./marketing-email-index.vue?vue&type=script&lang=ts&"
export * from "./marketing-email-index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports